<template>
  <v-dialog v-model="open" max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ $T('page.member.invite.created.link.title') }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex class="c-msg">{{ $T('page.member.invite.created.link.msg') }}</v-flex>
          <v-flex class="c-link">
            <v-tooltip top>
              <a
                slot="activator"
                :href="getInvitationLink(code, userLang)"
                class="custom-tooltip"
                v-clipboard:copy="getInvitationLink(code, userLang)"
                v-clipboard:success="onCopy"
                @click.stop.prevent=""
              >
                {{ getInvitationLink(code) }}
                <span class="tooltiptext">{{ $T('community_invitation.click_to_copy') }}</span>
              </a>
              <span>{{ $T('community_invitation.click_to_copy') }}</span>
            </v-tooltip>
          </v-flex>
          <v-flex class="c-expire">
            {{ $T('expire_date') }} : <strong>{{ unixToMin(expired) }}</strong>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="closeDialog">{{ $T('button.close') }}</v-btn>
        <v-btn
          color="clr-btn"
          flat
          v-clipboard:copy="getInvitationLink(code, userLang)"
          v-clipboard:success="onCopy"
          @click.stop.prevent=""
          ><v-icon left>mdi-content-copy</v-icon>{{ $T('page.member.invite.created.link.button') }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      open: false,
      id: null,
      code: null,
      expired: null,
    };
  },
  watch: {},
  computed: {},
  methods: {
    openDialog(id, code, expired) {
      this.code = code;
      this.id = id;
      this.expired = expired;
      this.open = true;
    },
    closeDialog() {
      this.open = false;
    },
    onCopy(e) {
      this.shortMsg($T('common.copy.link.succeed'));
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-link {
  text-align: center;
  font-size: 16px;
  padding-bottom: 8px !important;
}
.c-link a {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.c-expire {
  text-align: center;
  padding-top: 0px !important;
  font-size: 13px;
}
.c-expire strong {
  font-size: 18px;
}
</style>
